import React from 'react'
import styles from './styles.module.css'
import SimpleBlockContent from '../../../SimpleBlockContent'
import { $neutralGray50 } from '../../../../styles/colors/primitives'
import Img from '../../../Img' // task #67: canonical image component
import Text from '../../../Text'
import v2Styles from '../ProductTestimonialsV2/styles.module.css'

function ProductTestimonials({ title, testimonials }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        <div className={styles.title}>
          <SimpleBlockContent
            blocks={title.text}
            highlight={title.highlight}
            highlightSx={`color: ${$neutralGray50};`}
            noSpace/>
        </div>
        <div className={styles.testimonialsList}>
          {
            testimonials.map(t => (
              <div className={styles.testimonial} key={t.personName}>
                <div className={styles.imageWrapper}>
                  {/* task #67: descriptor via <Img> */}
                  <Img
                    image={t.image}
                    alt={t.personName}
                    objectFit="contain"
                  />
                </div>
                <div className={styles.description}>
                  <a className={styles.socialLink} href={t.socialLink} target="_blank" rel="noreferrer">
                    <div className={styles.nameAndSocial}>
                      <img className={v2Styles.icon} src={t.socialIcon?.src} alt="social-icon" width={24} height={24}/>
                      <Text type="large">{t.personName}</Text>
                    </div>
                  </a>
                  <Text type="regular">{t.personDescription}</Text>
                </div>
                <div className={styles.quote}>
                  <SimpleBlockContent blocks={t.quote} noSpace/>
                </div>
              </div>
            ))
          }

        </div>
      </div>
    </div>
  )
}

export default ProductTestimonials
